import { render, staticRenderFns } from "./jiankongbofang.vue?vue&type=template&id=8d7fcb98&scoped=true"
import script from "./jiankongbofang.vue?vue&type=script&lang=js"
export * from "./jiankongbofang.vue?vue&type=script&lang=js"
import style0 from "./jiankongbofang.vue?vue&type=style&index=0&id=8d7fcb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7fcb98",
  null
  
)

export default component.exports